import {createCredential, getPasskeyCreationOptions, registerUserPasskey} from '../../services/ApiService.js';
import { createToastMessages } from '../../utils/passkeyUtils';
import { useAuthentication } from './useAuthentication';

const GRAPH_API_PROPAGATION_DELAY = 2000;

export const usePasskeyAddOperation = ({ 
    accessToken, 
    userId, 
    ngcmfaExpiry, 
    onShowToast, 
    fetchPasskeys,
    currentPasskeys 
}) => {
    const { isTokenExpired, handleReAuthentication, cacheOperation } = useAuthentication({ onShowToast });

    const performAddPasskey = async () => {
        const currentCount = currentPasskeys.length;
        
        try {
            if (!accessToken || !userId) {
                throw new Error('Missing accessToken or userId');
            }

            const creationOptions = await getPasskeyCreationOptions(accessToken, userId);
            const creationCredential = await createCredential(creationOptions);
            // console.log('Created credential:', creationCredential);
            await registerUserPasskey(creationCredential, accessToken, userId);
            
            if (onShowToast) {
                onShowToast(createToastMessages.passkeyAdded());
            }
            
            await new Promise(resolve => setTimeout(resolve, GRAPH_API_PROPAGATION_DELAY));
            
            await fetchPasskeys({
                type: 'add',
                expectedCount: currentCount + 1
            }, {
                setLoadingState: true,
                showToast: true
            });

        } catch (err) {
            // console.error('Error adding passkey p+:', err);
            if (onShowToast) {
                if (err.name === 'NotAllowedError') {
                    onShowToast(createToastMessages.passkeyAddCancelled());
                } else {
                    onShowToast(createToastMessages.errorAdding(err.message));
                }
            }
        }
    };

    const handleAddPasskey = async () => {
        if (isTokenExpired(ngcmfaExpiry)) {
            const addOperation = { action: 'add' };
            cacheOperation(addOperation);
            await handleReAuthentication();
            return;
        }

        await performAddPasskey();
    };

    return {
        handleAddPasskey,
        performAddPasskey
    };
};
